import React, {useEffect} from 'react'
import {servicesData} from '../../fake-database/index'
import AOS from 'aos'; //animation library
import "aos/dist/aos.css";
import './services.css'
import Form from '../../components/Form'

const Services = () => {
    useEffect(() => {
        AOS.init({
          duration : 500
        });
      }, []);
    return (
        <section id="services" className="services  text-white">
            <div className="row mx-0">
                <div className="col-md-5 col-12 ms-auto p-0">
                    <div className='services-title'>
                        <h1 className=" text-uppercase pb-4" data-aos="fade-up">Services</h1>
                    </div>
                    <div className='services-deatils'>
                        <p data-aos="fade-up" data-aos-delay="150">{servicesData.deatils}</p>
                    </div>
                    <div className='services-line d-md-block d-none position-relative'></div>
                </div>
            </div>

            <div className="mt-md-5 mt-sm-2">
                <div className="services-main-photo">
                    <img src={servicesData.imagePath} alt="" className="img-fluid" />
                    <p>&nbsp;</p>
                </div>
            </div>

            <div className="services-content mt-md-5 mt-sm-2">
                {servicesData.typeOfService.map( service => (
                    <div id={service.pathName} className="service py-5" key={service.id}>
                        <div className="service-content">
                            <div className="service-content-title" data-aos="fade-up">
                                <h1 className="mb-0">{service.name}</h1>
                            </div>

                            <div className="service-content mt-md-5 mt-sm-2 mx-3">
                                     <div className='d-md-block d-none service-content-img'>
                                     <picture>
                                         <source media="(max-width:650px)" alt={service.imageAlt} srcSet={service.imagePath}/>
                                         <img src={service.imagePath} alt={service.imageAlt} className="img-fluid" width={880} height={640}/>
                                     </picture>
                                 </div>
                                
                               
                                
                                <div data-aos="fade-up" data-aos-delay="150" className='mt-md-4 mt-sm-2 service-content-deatils'> 
                                    <p>{service.deatils}</p>
                                    <ul className='mb-0 list-unstyled'><b >Type:</b>
                                    {service.types.map( type => (
                                            <li className='mx-1'>( {type} )</li>
                                    ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <Form/>
        </section>
    )
}

export default Services;